import React from 'react'
import StatCard from '../../../../Components/StatCard/StatCard';
import { formatTotal } from '../../../../lib/utils/utils';
import { useSelector } from 'react-redux';

function DashboardStats() {
    const dashboard = useSelector((state) => state.dashboard.dashboard.dashboard);

    return (
        <div className="grid grid-cols-4 gap-x-3 mx-5">
            {
                Object.keys(dashboard).length > 0 && 
                <>
                    <StatCard 
                        statName="Today's Sales" 
                        statValue={formatTotal(0, true)} 
                        hasPrice={true} 
                        // statTrend={12} 
                    />
                    <StatCard 
                        statName="Orders in progress" 
                        statValue={formatTotal(dashboard.orderInProgress)} 
                        hasPrice={false} 
                        // statTrend={12} 
                    />
                    <StatCard 
                        statName="On Favourites" 
                        statValue={formatTotal(dashboard.onFavourite)} 
                        hasPrice={false} 
                        // statTrend={-24} 
                    />
                    <StatCard 
                        statName="Estimated Payout as of today" 
                        statValue={formatTotal(0, true)} 
                        hasPrice={true} 
                    />
                </>
            }
        </div>
    );
}

export default DashboardStats;
